import styled from "styled-components";

const AnnouncementContainer = styled.div`
  width: 1246px;
  margin: 24px auto 8px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position:relative;

  .banner {
    width: 100%;
    min-height: 148px;
    ${'' /* max-height:${({showMore}) =>showMore ? "auto" : '136px'}; */}
    padding: 24px; /* Adds spacing */
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FEF4F2; /* Light pink background */
    position: relative;
    border-radius: 8px; /* Smooth edges */
    overflow: hidden;
    text-align: center;
    z-index:10;
    flex-direction:column;
  }

  .announcement-text {
  color: #184A61;
  text-align: center;
  width: 85%;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}

.announcement-text.collapsed {
  -webkit-line-clamp: 4; /* Show only 4 lines */
}

.announcement-text.expanded {
  -webkit-line-clamp: unset; /* Show full text */
}


  .prev-icon{
    margin-right:24px;
    cursor:pointer;
  }

  .nxt-icon{
    margin-left:24px;
    cursor:pointer;
  }

  .pagination{
    display:flex;
    margin-top:14px;
    align-items:center;
  }

  .active-announcement{
    color:  #184A61;

font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 125% */
  }


  /* Decorative curved circles */
  .banner::before,
  .banner::after {
    content: "";
    position: absolute;
    background-color: #FCCAC4; /* Light pink */
    border-radius: 50%;
    opacity: 0.8;
    z-index:-1;
  }

  /* Bottom-left curved circle */
  .banner::before {
    width: 220px;
    height: 220px;
    bottom: -110px;
    left: -80px;
  }

  /* Top-right curved circle */
  .banner::after {
    width: 180px;
    height: 180px;
    top: -90px;
    right: -70px;
  }

  /* Text styling inside the banner */
  .banner-text {
    font-size: 18px;
    color: #333;
    font-weight: 600;
    padding:28px;
  }

  .three-dots{
    position:absolute;
    top:0;
    right:10px;
    z-index:10;

  }

  .more-text{
    display:flex;
    justify-content:end;
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    cursor:pointer;
    width:100%;
    margin-right:24px;

/* Primary - Lato/Body-Text */
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 125% */
  }
`;

export { AnnouncementContainer };
